<template>
    <div class="google-map mb-3 mt-0" ref="mapa"><i class="fas fa-car"></i></div>
    
</template>

<script>
import VehicleController from "../../controllers/VehicleController"

export default {
    name: "google-map-markers",

    created(){
        
    },

    props: {
        latitude: { type: String },
        longitude: { type: String },        
    },
    
    data: function() {
        return {            
            markers: [],
            vehicleController: new VehicleController(this.$resource)
        }
    },

    mounted: function() {
        this.initMap()
    },

    methods: {
        async initMap() {
            const element = this.$refs.mapa
            const options = {
                zoom: 13,
                center: new google.maps.LatLng(this.latitude, this.longitude),
                disableDefaultUI: true,
                gestureHandling: 'greedy',
                styles:[{
                    "featureType": "poi",
                    "stylers": [{
                        "visibility": "off"
                    }]
                }]
            }
            const map = new google.maps.Map(element, options)
            await this.getVehiclesInArea()
            this.setMarkers(map)
        },

        async getVehiclesInArea(){
            let result = await this.vehicleController.getVehiclesInArea()            
            this.markers = result            
        },

        setMarkers(map){

            let image = {
                url: "https://img.icons8.com/ios-filled/50/000000/car.png",
                // This marker is 20 pixels wide by 32 pixels high.
                //  size: new google.maps.Size(20, 32),
                // The origin for this image is (0, 0).
                // origin: new google.maps.Point(0, 0),
                // // The anchor for this image is the base of the flagpole at (0, 32).
                // anchor: new google.maps.Point(0, 32)
            }
            for(let mark of this.markers){
                var marker = new google.maps.Marker({
                    position: new google.maps.LatLng(mark.lat , mark.long),
                    icon: image,
                    map: map
                })
            }   
            
        }
    }
}
</script>

<style scoped>
    .google-map {
    width: 100%;
    height: 95vh;
    margin: 0 auto;
    background: grey;
    }
</style>